// extracted by mini-css-extract-plugin
export default {"workcellConfigDialog":"workcellConfigDialog-oDDDi","title":"title-xNwkF"};